import { render, staticRenderFns } from "./ProductMiniCarousel.vue?vue&type=template&id=409e8d77"
import script from "./ProductMiniCarousel.vue?vue&type=script&lang=js"
export * from "./ProductMiniCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductMiniCarousel.vue?vue&type=style&index=0&id=409e8d77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports